<template>
	<b-modal id="modal-bookmark" title="Bookmark a link" :static="true">
		<span class="close" @click="$bvModal.hide('modal-bookmark')">
			<x-icon size="1.25x" class="custom-class"></x-icon>
		</span>
		<BookmarkForm @onSuccess="$bvModal.hide('modal-bookmark')"></BookmarkForm>
	</b-modal>
</template>

<script>
import BookmarkForm from '@/components/forms/bookmark';
import TextRenderer from '@/components/dashboard/text-renderer';
import CommentRenderer from '@/components/dashboard/comment-renderer';
import { CheckIcon, XIcon, ArrowDownIcon } from 'vue-feather-icons';
import _ from 'lodash';

export default {
	components: {
		BookmarkForm,
		TextRenderer,
		CommentRenderer,
		XIcon,
		CheckIcon,
		ArrowDownIcon,
	},
	data: function () {
		var obj = {
			lock: false,
			bucket: {
				title: '',
				color: 2,
			},
			copyText: '',
		};
		return obj;
	},
	watch: {
		currentSelection: {
			handler: function () {
				this.$store
					.dispatch('smartCopy/getCopy', this.$store.getters['note/sampleNote'])
					.then((str) => {
						this.copyText = str;
					});
			},
			immediate: true,
		},
	},
	computed: {
		options: function () {
			return this.$store.getters['smartCopy/options'];
		},
		currentSelection: function () {
			return this.$store.getters['smartCopy/currentSelection'];
		},
		computedOptions: function () {
			let options = this.options;
			let newOptions = _.groupBy(options, 'category');
			return newOptions;
		},
	},
	methods: {
		onSelect: function (option) {
			if (!option) {
				this.$store.dispatch('smartCopy/setCurrentSelection', null);
			} else {
				this.$store.dispatch('smartCopy/setCurrentSelection', option.name);
			}
		},
		getCopy: function () {
			return this.$store.dispatch('smartCopy/getCopy', note);
		},
	},
	mounted: function () {},
};
</script>

<style lang="scss">
#modal-smartcopy___BV_modal_outer_ {
	.modal-dialog {
		max-width: 1000px;
	}
	.modal-body {
		display: flex;
	}
	.arrow {
		display: flex;
		justify-content: center;
		margin-bottom: var(--margin-lg);
	}
	.preview {
		background-color: var(--g3);
		padding: var(--margin-lg);
		font-size: var(--font-size-sm);
	}
	.main-area {
		flex-grow: 1;
		margin-right: $lg-margins * 2;

		&__comment {
			margin-top: $lg-margins;
			font-size: var(--font-size-sm);
			opacity: 0.9;
		}
	}

	.sidebar-area {
		position: relative;
		width: 400px;
		min-width: 400px;
		padding-left: $lg-margins * 2;

		&:before {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			width: 1px;
			height: 100%;
			background-color: rgba(255, 255, 255, 0.1);
		}
	}
	.c-rows {
		&__item {
			article {
				margin-right: var(--margin);
			}

			.checkbox-control {
				margin-left: auto;
			}

			.description {
				font-size: var(--font-size-xs);
				display: block;
				opacity: 0.8;
			}
		}
	}

	@include media-breakpoint-down(sm) {
		.modal-body {
			flex-wrap: wrap;
		}
		.main-area {
			min-width: 100%;
			flex-grow: 1;
		}
		.sidebar-area {
			padding-left: 0;
			padding-top: var(--spacer-sm);
			margin-top: var(--spacer-sm);
			min-width: 100%;
			flex-grow: 1;

			&:before {
				width: 100%;
				height: 1px;
			}
		}
	}
}
</style>
